import { createFileRoute } from "@tanstack/react-router";
import { optionParam, textParam } from "@/utils/searchParams";

// The search box and the grid/categories switch live in the URL, so opening a
// tool and coming back shows the shelf the way it was left (NAV-45). Both views
// are listed; "grid" is the default, so it is simply never written — a URL that
// names it anyway still reads correctly.
const MY_TOOLS_VIEWS = ["grid", "categories"] as const;

export type MyToolsView = (typeof MY_TOOLS_VIEWS)[number];

export type MyToolsSearch = {
  q?: string;
  view?: MyToolsView;
};

export const Route = createFileRoute("/end-user/my-tools")({
  validateSearch: (search: Record<string, unknown>): MyToolsSearch => ({
    q: textParam(search.q),
    view: optionParam(MY_TOOLS_VIEWS, search.view),
  }),
});
